export default {
  namespaced: true,
  state: {
    currentMatch: undefined,
  },
  mutations: {
    CURRENT_MATCH(state, update) {
      if (!update.scoringEvents) update.scoringEvents = [];
      state.currentMatch = update;
    },
  },
};
